<template>
    <div class="myOrders">

        <el-row class="static" :gutter="20">
            <el-col :span="6">
              <el-card shadow="hover">
                <el-statistic  title="已提交工单">
                  <template slot="formatter"> {{ ordersData.submit_total }} </template>
                </el-statistic>
              </el-card>
            </el-col>
            <el-col :span="6">
              <el-card shadow="hover">
                <el-statistic  title="当前未受理工单">
                  <template slot="formatter"> {{ ordersData.wait_accept_total }} </template>
                </el-statistic>
              </el-card>
            </el-col>
            <el-col :span="6">
              <el-card shadow="hover">
                <el-statistic  title="已受理工单">
                  <template slot="formatter"> {{ ordersData.accepted_total }} </template>
                </el-statistic>
              </el-card>
            </el-col>
            <el-col :span="6">
              <el-card shadow="hover">
                <el-statistic  title="已完结工单">
                  <template slot="formatter"> {{ ordersData.close_total }} </template>
                </el-statistic>
              </el-card>
            </el-col>
        </el-row>


        <el-row class="formSearch">
          <el-card class="box-card" shadow="hover">
              <div slot="header" class="clearfix">
                <span>工单搜索</span>       
              </div>
              <div class="textItem">
                <el-form ref="formData" label-position="left" :inline="true" :model="formData"  size="small" label-width="85px">
                    <el-form-item label="输入查询" prop="sn">
                      <el-input clearable v-model="formData.sn" placeholder="工单号"></el-input>
                    </el-form-item>
                    <el-form-item label="产品型号" prop="goods_model">
                      <el-select
                        v-model="formData.goods_model"
                        clearable
                        filterable
                        remote
                        reserve-keyword
                        placeholder="请输入型号关键词"
                        :remote-method="remoteMethod"
                        :loading="modelLoading">
                        <el-option
                          v-for="item in modelOptions"
                          :key="item.id"
                          :label="item.model"
                          :value="item.model">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="工单类型：" prop="type">
                      <el-select v-model="formData.type" clearable placeholder="请选择">
                        <el-option v-for="item in selectType" :key="item.value" :label="item.text " :value="item.value"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="工单状态："  prop="status">
                      <el-select v-model="formData.status" clearable placeholder="请选择活动区域">
                        <el-option v-for="item in ordersStstus" :key="item.value" :label="item.text " :value="item.value"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="创建时间" prop="time">
                      <el-date-picker
                        v-model="formData.time"
                        value-format="timestamp"
                        format="yyyy 年 MM 月 dd 日"
                        unlink-panels
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" @click="searchEvent">查询</el-button>
                      <el-button @click="resetForm('formData')">重置</el-button>
                      <el-button type="primary" @click="reOrders">发布工单</el-button>
                    </el-form-item>
                </el-form>
              </div>
              <div class="formTable">
                  <el-table
                    :data="tableData"
                    border
                    stripe
                    style="width: 100%"
                    @cell-click="cellClick">
                      <el-table-column
                        prop="title"
                        label="标题"
                        class-name="snLabel"
                        >
                        <template slot-scope="scope">
                          <el-badge  :value="scope.row.is_update == 0?'':'new'" class="item">
                            <div size="small">{{ scope.row.title }}</div>
                          </el-badge>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="goods_model"
                        label="产品型号"
                        >
                      </el-table-column>
                      <el-table-column
                        prop="last_reply_content"
                        label="最新回复"
                        >
                        <template slot-scope="scope">
                            <div style="overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 3;">{{ scope.row.last_reply_content == ''?'':scope.row.timeDivision }} {{ scope.row.last_update_person }} {{  scope.row.last_reply_content == ''?'':':' }} {{ scope.row.status == "已完结"?"已完结":scope.row.last_reply_content }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="status"
                        label="状态"
                        >
                      </el-table-column>
                      <el-table-column
                        prop="type"
                        label="工单类型"
                        >
                      </el-table-column>
                      <el-table-column
                        prop="reminder_count"
                        label="催单次数"
                        >
                      </el-table-column>
                      <el-table-column
                        fixed="right"
                        label="操作"
                        >
                        <template slot-scope="scope">
                          <el-button
                            type="text"
                            size="small"
                            v-if="scope.row.status == '已退回'?false:(scope.row.status == '已完结'?false:true)">
                            <el-popconfirm confirm-button-text='是的' cancel-button-text='取消' icon="el-icon-info"
                              icon-color="#66b1ff" title="您确认催单吗？" @confirm="reminders(scope.row)">
                              <el-button slot="reference" type="text" size="small">催单</el-button>
                            </el-popconfirm>
                          </el-button>
                          <el-button
                            type="text"
                            size="small">
                            <el-popconfirm confirm-button-text='是的' cancel-button-text='取消' icon="el-icon-info"
                              icon-color="#66b1ff" title="您确认删除该工单么？" @confirm="confirmEvent(scope.row)">
                              <el-button slot="reference" type="text" size="small">删除</el-button>
                            </el-popconfirm>
                          </el-button>
                        </template>
                      </el-table-column>
                  </el-table>
              </div>
              <div class="pages">
                <el-pagination
                  background
                  layout="prev, pager, next"
                  :total="total"
                  :page-size="pageSize"
                  @current-change="currentClick">
                </el-pagination>
              </div>
          </el-card>
        </el-row>



    </div>
</template>

<script>
import { Row } from 'element-ui';
import * as dd from 'dingtalk-jsapi'; // 此方式为整体加载，也可按需进行加载
import {getOrderType,getOrderCounter,getOrderTable,reminder,getOrderSearch,getMyOrder,getOrstatus,orderRemove,getMyOrderSearch,modelSelect } from '../../utils/api'
export default {
  props: {},
  data() {
    return {
      page:1,
      total:0,
      pageSize:10,
      ordersData:{
        submit_total:'', //已提交工单总数
        wait_accept_total:'', // 未受理工单总数
        accepted_total:'', //已受理工单总数
        close_total:'' //已完成工单总数
      },
      formData:{
          sn:'',
          type:'',
          time:'',
          status:'',
          goods_model:''
      },
      tableData:[],
      selectType:[],
      ordersStstus:[],
      modelLoading:false,
      modelOptions:[]
    };
  },
  methods: {
    onSubmit(){
      console.log('搜索');
    },
    deleteRow(index, rows) {
        var that = this
        console.log(rows[index],'rowssss');
        var param = {
          order_id:rows[index].id
        }
        orderRemove(param)
        .then(res=>{
          console.log(res,'删除成功');
          if(res.message.status == 'success'){
              that.$message.success('删除成功')
          }
        })
        .catch(err=>{
          console.log(err,'err');
        })
    },
    //确认删除工单
    confirmEvent(row){
      console.log(row,'row');
      var that = this
      var param = {
        order_id:row.id
      }
      orderRemove(param)
      .then(res=>{
        console.log(res,'删除操作');
        if(res.message.status == 'success'){
            that.$message.success('删除成功')
            that.getOrderTables()
            that.getCounter()
        }
      })
      .catch(err=>{
        console.log(err,'err');
      })
    },
    //工单统计
    getCounter(){
      var that = this
      getOrderCounter()
      .then(res=>{
        that.ordersData = res.data
      })
      .catch(err=>{
        console.log(err,'err');
      })
    },
    //获取工单类型
    getType(){
      var that = this
      that.selectType = []
      getOrderType()
      .then(res=>{
          res.data.forEach(item=>{
            that.selectType.push({
              text:item.type,
              value:item.type
            })
          })
      })
      .catch(err=>{
        console.log(err,'err');
      })
    },
    //获取工单状态列表
    getOrderStatus(){
      var that = this
      getOrstatus()
      .then(res=>{
        if(res.message.status == 'success'){
            that.ordersStstus = res.data.list
            that.ordersStstus.forEach(item=>{
              item['text'] = item.title
            })
        }else{
          that.$message.error(res.message.text)
        }
      })
      .catch(err=>{
        console.log(err,'err');
      })
    },
    //工单查询
    searchEvent(){
      var that = this
      var times = that.formData.time
      if(times === ''){
        times = null
      }
      if(Array.isArray(times) && times[0] === ''){
        times = null
      }
      var params = {
          page : that.page,
          pagesize:that.pageSize,
          sn:that.formData.sn,
          type:that.formData.type,
          begin_time:times == null?'':times[0]/1000,
          end_time:times == null?'':times[1]/1000,
          status:that.formData.status,
          goods_model:that.formData.goods_model
      }
      getMyOrderSearch(params)
      .then(res=>{
        console.log(res,'工单查询');
        if(res.message.status == 'success'){
          that.tableData = res.data
          that.tableData.forEach(item=>{
            var arr = item.last_update_person.split('/')
            item.last_update_person = arr[arr.length-1]
            item["timeDivision"] = that.initTimeship(item.last_reply_time)
          })
          that.getStatus(that.tableData)
          that.total = res.total
        }else{
          // that.$message.error(res.message.text)
          that.tableData = []
          that.total = 0
        }
      })
      .catch(err=>{
        console.log(err,'err');
      })
    },
    //重置
    resetForm(formName){
      this.$refs[formName].resetFields();
    },
    //当前页
    currentClick(e){
      console.log(e,'当前页');
      var that = this
      that.page = e
      if(that.formData.sn !== '' || that.formData.type !== '' || (that.formData.time !== null && that.formData.time !== '') || that.formData.status !== ''){
        console.log('查询接口');
            that.searchEvent()
       }else{
            that.getOrderTables()
       }
    },
    cellClick(row, column, cell, event){
      console.log(cell,'cell');
      console.log(row,'row');
      if(column.label == '标题'){
          this.$router.push('/orderDetail/orderDetail?jumpId='+(row.id))
      }
    },
    reOrders(){
      this.$router.push({name:'reOrders'})
    },
    //获取我的工单
    getOrderTables(){
      var that = this
      var params = {
        page:that.page,
        pagesize:that.pageSize
      }
      getMyOrder(params)
      .then(res=>{
        console.log(res,'我的工单列表');
        if(res.message.status == 'success'){
          that.tableData = res.data
          that.tableData.forEach(item=>{
            var arr = item.last_update_person.split('/')
            item.last_update_person = arr[arr.length-1]
            item["timeDivision"] = that.initTimeship(item.last_reply_time)
          })
          that.getStatus(that.tableData)
          that.total = res.total
        }else{
          that.tableData = []
          that.total = 0
        }
      })
      .catch(err=>{
        console.log(err,'err');
      })
    },
    //催单
    reminders(row){
      var params = {
        order_id:row.id
      }
      reminder(params)
      .then(res=>{
        console.log(res,'催单ssss');
        if(res.message.status == 'success'){
          this.$message.success('催单成功')
          this.tableData.forEach(item=>{
            if(item.id == row.id){
                item.reminder_count = res.data.reminder_count
            }
          })
        }else{
          this.$message.error(res.message.text)
        }
      })
      .catch(err=>{
        console.log(err,'err');
      })
    },
    //时间戳转时、分、秒
    initTimeship(time){
      const date = new Date(time * 1000)
      const Y = date.getFullYear()
      const M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      const D = date.getDate()
      const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours());
      const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
      const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
      return `${h}:${m}`
    },
    //型号模糊查询触发
    remoteMethod(value){
      console.log('促发了');
      this.modelOptions = []
      if(value !== ''){
        this.modelLoading = true;
        var params = {
          model:value
        }
        modelSelect(params)
        .then(res=>{
          console.log(res,'模糊查询结果');
          if(res.message.status == 'success'){
            this.modelOptions = res.data
            this.modelLoading = false
          }else{
            this.modelLoading = false
            this.$message.error(res.message.text)
          }
        })
        .catch(err=>{
          this.$message.error(err)
          this.modelLoading = false
          console.log(err);
        })
      }else{
        this.modelOptions = []
      }
    },


  },
  created() {},
  mounted() {
    this.getType()
    this.getOrderStatus()
  },
  activated(){
    this.getCounter()
    this.getOrderTables()
    this.searchEvent()
  }
};
</script>
<style lang="scss" scoped>
.row-bg{
  background: #e3e2e2;
  line-height: 50px;
  padding: 0 20px;
}

.formSearch{
  background: #ffffff;
  margin-top: 10px;
  h3{
    padding-top: 10px;
    color: #333;
    font-size: 16px;
  }
}

.pages{
  text-align: right;
  margin-top: 20px;
}

.formTable{
  ::v-deep  .snLabel{
    color: #409EFF;
    margin: 10px 0;
    div:hover{
      // border-bottom: 2px solid #65afec;
      cursor: pointer;
    }
    .cell{
    padding-top: 10px;
    padding-right: 30px;
  }
  }

  ::v-deep .is-leaf{
    color: #666 !important;
    div:hover{
      border-bottom: none;
    }
  }
}

</style>